import { render, staticRenderFns } from "./addMedicalCase.vue?vue&type=template&id=d67a982c&scoped=true&"
import script from "./addMedicalCase.vue?vue&type=script&lang=js&"
export * from "./addMedicalCase.vue?vue&type=script&lang=js&"
import style0 from "./addMedicalCase.vue?vue&type=style&index=0&id=d67a982c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67a982c",
  null
  
)

export default component.exports